module.exports = "<div class=\"info-wrapper\" [class.loading]=\"loading\" (click)=\"saveInstruction()\">\r\n    <i [className]=\"'fa-solid info-component ' + ico\"\r\n       [ngStyle]=\"{'color': color}\" data-toggle=\"tooltip\"\r\n       [attr.data-placement]=\"direction\" [attr.title]=\"inputData\"></i>\r\n<!--    <img *ngIf=\"loading\" src=\"/assets/img/loading.gif\" alt=\"Loading...\" />-->\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/component-info.component/component-info.component.html
// module id = ./src/app/shared/components/component-info.component/component-info.component.html
// module chunks = main